import React from 'react'
import { ReactComponent as DeleteIcon } from "assets/rounds_icons/delete_icon.svg";
import { ReactComponent as UploadDocumentsIcon } from "assets/rounds_icons/upload_documents_icon.svg";
import { makeStyles, styled } from '@mui/styles';
import { ReactComponent as ReportsIcon } from 'assets/nav_icons/reports.svg';
import format from 'date-fns/format';
import CustomValidationText from 'ui-components/CustomValidationText';
import AsyncTableListing from 'ui-components/AsyncTableListing';
import { Box, capitalize, Card, Checkbox, CircularProgress, Divider, FormControlLabel, Grid, IconButton, MenuItem, Select, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import PerfectScrollbar from "react-perfect-scrollbar";
import RoundStepsBackground from "assets/rounds_icons/round_list_bottom.png";
import TopIcon from "assets/rounds_icons/TopIcon.svg";
// import TopIcon from "assets/rounds_icons/top_icon.svg";
import BottomIcon from "assets/rounds_icons/BottomIcon.svg";
import { useTheme } from '@emotion/react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { containerRef, handleFormSubmit, hasFormChanges, hasPermission } from 'utils/index';
import { TabContext, TabPanel } from '@mui/lab';
import { AddReport, DeleteReportDocument, FetchReportDetails } from 'api/org/report';
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper';
import BreadcrumbHeader from 'layout/BreadcrumbsHeader';
import NeedHelpButton from 'ui-components/NeedHelpButton';
import { Secondary, Primary as CustomButton } from 'ui-components/Buttons';
import { FieldArray, Form, FormikProvider, useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { FetchAllDocumentTypes } from 'api/utils';
import * as Yup from "yup"
import toast from "react-hot-toast";
import CustomToast from "ui-components/CustomToast";
import CustomInputField from "ui-components/formik/CustomInputField";
import CustomLabel from "ui-components/CustomLabel";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import CustomMenu from "ui-components/CustomMenu";
import { VisuallyHiddenInput } from "ui-components/VisuallyHiddenInput";
import Cookies from "js-cookie";
import CustomRichTextEditor from "ui-components/formik/CustomRichTextEditor";
import { useToast } from "context/ToastContext";
import UnsavedChangesPopup from 'ui-components/popups/UnsavedChangesPopup';


const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    '& > .Mui-disabled.MuiTabs-scrollButtons': {
      display: 'none',
      transition: 'all 1s ease'
    },
  },
  DateRangePicker: {
    '& > .rs-picker-input-group > input': {
      fontSize: "1rem",
      padding: '13.2px 15px',
    },
    '& .rs-input-group:focus-within': {
      borderColor: theme.palette.customColors.g75,
      boxShadow: 'none',
      outline: 'none',
      borderRadius: '4px'


    },
    '& .rs-input-group': {
      borderColor: theme.palette.customColors.g75 + " !important",
      // borderRadius:'8px'
    }


  }
}));

const CardHeader = ({ title, action, actionText, actionStyle = {}, CardHeaderStyle = {} }) => {
  return <>
    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} mb={"0.75rem"} sx={{ ...CardHeaderStyle }}>
      <Typography fontWeight={700} fontSize={"1.25rem"}>
        {title}
      </Typography>
      {/* {action && <Secondary
          component="label"
          role={undefined}
          tabIndex={-1}
          sx={{
              minWidth: "0 !important",
              border: `1px solid #D0D5DD !important`,
              display: "flex",
              gap: '0.5rem',
              paddingInline: '0.5rem 0.875rem',
              ...actionStyle,
          }}
          onClick={action}
      >
          <EditIcon
              style={{
                  width: 20,
                  height: 20,
              }} />
          <Typography>
              {actionText ? actionText : "Edit"}
          </Typography>
      </Secondary>} */}
    </Box>
    <Divider />
  </>
}

const CreateReport = () => {
  const theme = useTheme();
  const { addToast } = useToast();
  const classes = useStyles();
  let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);
  const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
  const navigate = useNavigate();
  const scrollbarRef = React.useRef(null);
  const buttonRef = React.useRef(null);

  const scrollToBottom = () => {

    // Find the first visible validation message
    setTimeout(() => {
      if (buttonRef && buttonRef.current && buttonRef.current.offsetParent !== null) {
        buttonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 10)
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Report name is required'),
    // overview: Yup.string().required('Overview is required'),
    overview: Yup.string().required("Overview is required").test(
      'no-html-tags',
      'Overview is required',
      (value) => {
        const plainText = value?.replace(/<[^>]*>/g, "");
        return plainText && plainText.trim().length > 0;
      }
    ).test(
      'richText-length',
      'Overview must be between 1 and 250 characters',
      value => {
        const strippedValue = value.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, '').replace(/\s+/g, '').trim();
        return strippedValue.length >= 1 && strippedValue.length <= 250;
      }
    ),
    duration: Yup.object().required("Duration is required").nonNullable("Duration is required"),
    report_documents: Yup.array().of(
      Yup.object().shape({
        document_name: Yup.string().required('Document name is required'),
        type_id: Yup.string()
          .required('Document type is required')
          .test("type-id", "Document type is required", (value) => value !== '0'),
        reports: Yup.string().required('Document file is required'),
      })
    ).required('At least one document is required')
  });

  const initialValues = {
    name: '',
    overview: '',
    duration: null,
    // duration: {
    //   from_date: '',
    //   to_date: ''
    // },
    report_documents: [
      {
        document_name: '',
        type_id: "0",
        reports: null
      }
    ],
    share_investor: false
  };

  const columns = React.useMemo(
    () => [
      { Header: 'Document Name', accessor: 'document_name', minWidth: 300 },
      { Header: 'Document Type', accessor: 'type_info.name', minWidth: 300 },
      {
        Header: "", accessor: 'actions', minWidth: 50
      },
    ],
    []
  );
  // const documents = [
  //   {
  //       filename: 'Tech requirements.pdf',
  //       type: 'MIS Reports',
  //   },
  //   {
  //       filename: 'Tech requirements.pdf',
  //       type: 'MIS Reports',
  //   }
  // ]
  // const [value, setValue] = React.useState("")
  const matchesUpXs = useMediaQuery(theme.breakpoints.up('xs'));
  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchUpLg = useMediaQuery(theme.breakpoints.up('lg'));
  const matchUpXl = useMediaQuery(theme.breakpoints.up('xl'));
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const report_id = Cookies.get("report_id") || null;
  // const { id: report_id } = useParams();
  const { data: reportDetailData, isRefetching: isRefetchingReportsDetail, isLoading: isLoadingReportDetail, refetch: refetchReportDetail } = FetchReportDetails(report_id)
  const [roundID, setRoundID] = React.useState(report_id || null)
  const isEditMode = !!report_id
  const reportTabs = [
    {
      label: `${isEditMode ? "Edit" : "Add"}`,
      icon: ReportsIcon,
      value: "report",
    },
    // {
    //   label: "Investors",
    //   icon: RoundInvestorsIcon,
    //   value: "investors",
    // },
  ]

  const BreadCrumbActions = () => {
    return (
      <>
        {/* {(isCreatingRound || isUploadingDocuments) && matchesUpMd && <Typography sx={{ marginRight: "1rem" }} display={"flex"} alignItems={'center'} gap={1} fontSize={"14px"} fontWeight={600} color={theme.palette.customColors.g200}>
                    <SavingIcon width={24} height={24} className="saving-icon" />
                    <span>Saving...</span>
                </Typography>} */}
        <NeedHelpButton />
      </>
    );
  };

  const RowActions = (formik) => {
    // console.log(formik?.rows?.original,"formik")
    let document_id = formik?.row?.original?._id;
    return <React.Fragment>
      <IconButton onClick={() => {
        if (window.confirm("Are you sure you want to delete this document?") == true) {
          deleteReportDocumentAsync({ document_id: document_id }, {
            onSuccess: (succ) => {
              // console.log(succ, 'succ')
              addToast("Document Deleted!", "success")
              // toast.success(
              //   <CustomToast message={"Document Deleted!"} style={{ padding: "0px 15px" }} closeIcon={true} closeIconPosition={"center"} />,
              //   {
              //     duration: 2000,
              //     position: "top-right",
              //   }
              // );
              refetchReportDetail();
            },
            onError: (err) => {
              addToast(err?.response?.data?.message, "error")
              // toast.error(
              //   <CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} closeIconPosition={"center"} />,
              //   {
              //     duration: 2000,
              //     position: "top-right",
              //   }
              // );
            }
          });
        }
        else {
          return;
        }

      }
      }>
        <DeleteIcon color="#F94F4F" />
      </IconButton>
    </React.Fragment>
  }
  const { data: document_types, isRefetching: isRefetchingDocumentTypes, isLoading: isLoadingDocumentTypes, refetch: refetchDocumentTypes } = FetchAllDocumentTypes()
  const [step, setStep] = React.useState(1);

  const {
    mutateAsync: addReportAsync,
    isLoading: isAddingReport,
    status: addReportStatus,
    error: addReportError,
    data: addReportResponse
  } = AddReport();
  const {
    mutateAsync: deleteReportDocumentAsync,
    isLoading: isdeletingReportDocument,
    status: deleteReportDocumentStatus,
    error: deleteReportDocumentError,
    data: deleteReportDocumentResponse
  } = DeleteReportDocument();

  const handleSubmit = (values) => {
    // console.log(values);
    const formData = new FormData();
    formData.append("name", values.name)
    formData.append("overview", values.overview)
    formData.append("from_date", values?.duration?.from_date)
    formData.append("to_date", values?.duration?.to_date)
    values?.share_investor && formData.append("share_investor", values?.share_investor)

    values?.report_documents?.forEach((doc, index) => {
      if (doc?.reports?.size) {
        formData.append(`document_name[${index}]`, doc?.document_name)
        formData.append(`type_id[${index}]`, doc?.type_id)
        formData.append(`reports${index}`, doc?.reports)
      } else {
        formData.append(`document_name[${index}]`, doc?.document_name)
        formData.append(`type_id[${index}]`, doc?.type_id)
        formData.append(`reports${index}`, doc?.reports)
      }
    });

    formData.append(`startup_id`, startup_id)

    let value = currentIndex;

    if (isEditMode) {
      if (value != "investors") {
        formData.append("report_id", roundID)
        addReportAsync(formData)
      }
      else {
        navigate(-1)
      }
    }
    else {
      if (value != "investors") {
        addReportAsync(formData)
      }
      else {
        navigate(-1)
      }
    }

  };

  const formik = useFormik({
    initialValues: isEditMode && !isLoadingReportDetail ? reportDetailData?.report : initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    enableReinitialize: true,
  })

  React.useEffect(() => {
    if (addReportResponse && addReportResponse?.data?.statusCode == 200) {
      // if (step == 2 && value !== "investors") {
      //   // toast.success(`Report ${!isEditMode ? 'Created' : 'Updated'}!`)
      //   setValue("investors");

      //   addReportResponse?.data?.data?._id && navigate(`/reports/${window.location.pathname?.includes("create_report") ? "create_report" : 'edit_report'}/${addReportResponse?.data?.data?._id}`)
      //   addReportResponse?.data?.data?._id && setRoundID(addReportResponse?.data?.data?._id)
      //   addReportResponse?.data?.data?._id && refetchReportDetail()
      //   addReportResponse?.data?.data?._id && formik.setFieldValue("report_documents", [])
      //   // addReportResponse?.data?.data?._id && 
      //   window.document
      //     .getElementById("sidebar-scroller")
      //     .scrollTo(0, 0);

      // }
      // else 
      // if (step == 1 && value !== "investors") {
      //   // toast.success(`Report ${!isEditMode ? 'Created' : 'Updated'}!`)
      //   navigate(-1);
      // }
      // else {
      navigate(-1);
      // }
    }
    else if (addReportResponse && addReportResponse?.data?.statusCode != 200) {
      // toast.error(
      //   <CustomToast message={createRoundError?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} closeIconPosition={"center"} />,
      //   {
      //     duration: 2000,
      //     position: "top-right",
      //   }
      // );
      // toast.error("Internal Server Error")
      // console.log("error", addReportError)
    }
  }, [addReportResponse?.data?.statusCode]);


  const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);

  const handleDiscardChanges = () => {
    navigate(-1);
  }

  const handleCloseUnsaved = () => {
    setHasUnsavedChanges(false)
  }

  return (
    <ThemeBGWrapper>

      <UnsavedChangesPopup open={hasUnsavedChanges} handleClose={handleCloseUnsaved} handleSubmission={handleDiscardChanges} key={"Update Profile"} />
      <BreadcrumbHeader
        breadcrumbTitle={Cookies.get("selected_startup_name") + ` (Reports)`}
        title={isLoadingReportDetail || isLoadingDocumentTypes ? "Loading..." : `${isEditMode ? `${hasPermission("startups_new", "edit", userPermissions) ? "Edit" : "View"} ${reportDetailData?.report?.name?.length > 0 ? "(" + reportDetailData?.report?.name + ")" : "Report"}` : "Add"}`}
        // title={isLoadingRoundDetails ? "Loading..." : isEditMode ? `Edit ${matchesUpMd ? roundDetails?.round_name : 'Report'}` : 'Create Report'}
        Actions={BreadCrumbActions}
      />
      {(isLoadingReportDetail || isLoadingDocumentTypes) ?
        <Grid container xs={12} display={"flex"} height={"100%"} maxHeight={"85vh"} sx={{ padding: { xs: "0 1rem", sm: '0 1rem 1rem 1rem', md: "0 2rem 1rem 2rem" }, width: '100%' }}>
          <Grid item xs={12} className="skeleton" height={"100%"} width={"100%"} borderRadius={"24px"}>

          </Grid>
        </Grid> :
        <>
          <Grid
            container
            xs={12}
            sx={{
              // height: "calc(100dvh - 118px)",
              height: '100%',
              maxHeight: { xs: "90%", sm: "93%", md: '85dvh' },
              // overflow: "hidden",
              padding: { xs: "0 1rem", sm: '0 1rem 1rem 1rem', md: "0 2rem 1rem 2rem" },
            }}
          >
            <Grid
              xs={12}
              item
              container
              sx={{
                backgroundColor: "#FFFAF5",
                borderRadius: { xs: "24px", sm: "24px" },
                height: "100%",
              }}
            >
              <TabContext value={currentIndex}>
                <Grid
                  item
                  container
                  // xs={12}
                  // // sm={5}
                  // md={6}
                  // lg={7.4}
                  sx={{
                    // width: { xs: "100%", md: '70%', lg: '70%', xl: '70%' },
                    padding: { xs: '0rem', md: '2rem', lg: "2.5rem" },
                    paddingBlock: "0.5rem !important",
                    width: "100%",
                    maxWidth: "900px"
                    // border: `1px solid ${theme.palette.customColors.g75}`, bgcolor: theme.palette.customColors.whiteBG, borderRadius: "4px"
                  }}
                  // gap={3}
                  gap={"1rem"}
                  marginTop={0}
                  marginInline={"auto"}
                  display={"flex"}
                  alignItems={"flex-start"}
                  // alignContent={"space-around"}
                  alignContent={"space-between"}
                  justifyContent={"space-between"}
                  // padding={"2.5rem"}
                  paddingBottom={0}
                  position={"relative"}
                >
                  {/* {!matchesUpMd &&
                    <Box width={"100%"}>
                      {reportTabs &&
                        reportTabs?.length > 0 ?
                        <>
                          <Typography marginInline={"auto"} flexWrap={"wrap"} variant="h6"
                            fontSize="1rem"
                            color={theme.palette.customColors.g300}
                            fontWeight={700} textAlign={"center"} marginBottom={1}>
                            <span>{reportTabs[currentIndex]?.label} ({`${currentIndex + 1}/${reportTabs?.length}`})</span>
                            <Divider sx={{ marginTop: 1, marginBottom: 2, marginInline: 'auto', maxWidth: '50%' }} />
                          </Typography>
                        </>
                        : ''}
                    </Box>
                  } */}

                  {/* <TabPanel sx={{ paddingInline: 0 }} value={0}> */}
                  <FormikProvider value={formik}>
                    <Form onSubmit={e => e.preventDefault()} style={{ width: "100%" }} >

                      <Card sx={{ borderRadius: "10px", border: `1px solid ${theme.palette.customColors.b50}`, overflow: 'hidden', boxShadow: 'none', paddingTop: "1rem" }}>
                        <CardHeader title={"Report Details"} CardHeaderStyle={{ paddingInline: "1rem" }} />
                        <PerfectScrollbar containerRef={containerRef} style={{
                          minHeight: "58dvh",
                          height: "100%",
                          width: "100%",
                          maxHeight: "calc(-270px + 100dvh)",
                          paddingRight: "1rem",
                          marginTop: 0,
                          paddingBottom: "1rem",
                        }}
                          ref={scrollbarRef}
                          id='sidebar-scroller'
                          className="scrollbar-container"
                        >
                          <Grid container columnSpacing={2} rowSpacing={0} sx={{ paddingInline: "1rem", paddingTop: '1rem' }}>
                            <Grid item xs={12} sm={6}>
                              <CustomInputField
                                fullWidth
                                name="name"
                                label="NAME"
                                placeholder="Enter name"
                                disabled={!hasPermission("startups_new", "add", userPermissions) && !hasPermission("startups_new", "edit", userPermissions)}
                                value={formik?.values?.name}
                                onChange={(e) => formik?.setFieldValue("name", e.target.value?.charAt(0)?.toUpperCase() + e.target.value?.slice(1))}
                              // sx={{
                              //   marginBottom: "0.5rem"
                              // }}
                              />
                            </Grid>


                            <Grid item xs={12} sm={6} height={"min-content"}>
                              <CustomLabel>DURATION</CustomLabel>
                              <DateRangePicker
                                className={`${classes.DateRangePicker}`}
                                ranges={[]}
                                placement="bottomEnd"
                                style={{ width: '100%' }}
                                placeholder="Select date"
                                format="dd-MMM-yyyy"
                                disabled={!hasPermission("startups_new", "add", userPermissions) && !hasPermission("startups_new", "edit", userPermissions)}
                                onChange={(value) => {
                                  formik?.setFieldValue(
                                    'duration',
                                    value !== null
                                      ? { from_date: moment(value[0])?.toISOString(), to_date: moment(value[1])?.toISOString() }
                                      : null
                                  );
                                }}
                                value={
                                  formik.values?.duration !== null
                                    ? [new Date(formik.values?.duration?.from_date), new Date(formik.values?.duration?.to_date)]
                                    : null
                                }
                                renderValue={([from_date, to_date]) => {
                                  return (
                                    format(from_date, 'dd-MMM-yyyy') + ' - ' + format(to_date, 'dd-MMM-yyyy')
                                  );
                                }}
                              />

                              <CustomValidationText value={formik.errors.duration} />
                            </Grid>


                            {/* <Grid item xs={12} marginTop={{ xs: 2, sm: 0 }}>
                            <CustomInputField
                              fullWidth
                              name="overview"
                              placeholder="Enter overview details"
                              label="OVERVIEW"
                              multiline
                              // rows={3}
                              minRows={3} maxRows={4} maxLength={250} data-problem-solving={250 - formik.values?.overview?.length + `${(250 - formik.values?.overview?.length) > 1 ? " characters" : " character"} left`}
                              sx={{
                                "::after": {
                                  content: 'attr(data-problem-solving)',
                                  position: "absolute",
                                  bottom: formik?.errors?.overview?.length > 0 ? 30 : 5,
                                  right: 5,
                                  background: 'white',
                                  color: 'graytext',
                                  padding: "0 5px",
                                  fontSize: "0.75rem"
                                },
                              }}
                              // sx={{
                              //   marginBottom: 0
                              // }}
                              value={formik?.values?.overview}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value.length <= 250) {
                                  formik.setFieldValue(`overview`, capitalize(e.target.value))
                                }
                                else {
                                  formik.setFieldValue(`overview`, String(capitalize(e.target.value))?.substring(0, 250))
                                }
                              }}
                            />
                          </Grid> */}
                            <Grid item xs={12} sm={12} height={"min-content"}>
                              <CustomRichTextEditor
                                name="overview"
                                label={
                                  <Box display="flex" alignItems="center" gap="4px">
                                    Overview
                                  </Box>
                                }
                                readOnly={!hasPermission("startups_new", "add", userPermissions) && !hasPermission("startups_new", "edit", userPermissions)}
                                placeholder={"Enter overview details"}
                                value={formik.values?.overview}
                                handleChange={(newValue) => {
                                  if (newValue.length <= 250) {
                                    formik.setFieldValue(`overview`, capitalize(newValue))
                                  }
                                  else {
                                    formik.setFieldValue(`overview`, String(capitalize(newValue))?.substring(0, 250))
                                  }
                                }
                                }
                              />
                              {formik.errors.overview && formik.touched.overview && (
                                <CustomValidationText value={formik.errors.overview} />
                              )}
                            </Grid>

                            {(hasPermission("startups_new", "edit", userPermissions) || hasPermission("startups_new", "add", userPermissions)) && <Grid item xs={12} sm={12} height={"min-content"} mt={1.5}>
                              <FieldArray
                                name="report_documents"
                                render={(arrayHelpers) => (
                                  <React.Fragment>
                                    {formik?.values?.report_documents?.length > 0 &&
                                      formik?.values.report_documents?.map((item, index) => (
                                        <React.Fragment key={index}>
                                          <Grid container item columnSpacing={2}>
                                            <Grid item xs={12} sm={3} pt={1}>
                                              <CustomInputField
                                                name={`report_documents.${index}.document_name`}
                                                label="DOCUMENT NAME"
                                                placeholder="Enter document name"
                                                value={item?.document_name}
                                                onChange={(e) => formik?.setFieldValue(`report_documents.${index}.document_name`, e.target.value?.charAt(0)?.toUpperCase() + e.target.value?.slice(1))}
                                                fullWidth
                                                sx={{
                                                  '& > .MuiInputBase-root > input.MuiInputBase-input': { padding: "13.5px 14px 13.5px 14px" },
                                                  borderRadius: '8px',
                                                  height: "100%",
                                                  margin: 0,
                                                }}
                                              />
                                            </Grid>
                                            <Grid item xs={12} sm={3} height={"min-content"} pt={1}>
                                              <CustomLabel>DOCUMENT TYPE</CustomLabel>
                                              <Select
                                                size="small"
                                                fullWidth
                                                name={`report_documents.${index}.type_id`}
                                                placeholder='Select document type'
                                                value={item?.type_id}
                                                // onChange={(e) => {}
                                                //   // formik.setFieldValue(
                                                //   //   "runway_left",
                                                //   //   e.target.value
                                                //   // )
                                                // }
                                                onChange={formik?.handleChange}
                                                sx={{
                                                  background: theme.palette.customColors.whiteBG,
                                                  paddingBlock: "6px",
                                                  margin: 0,
                                                }}
                                              >
                                                <MenuItem value={"0"}>Select document type</MenuItem>
                                                {document_types && document_types?.length > 0 && document_types?.filter(item => item?.name != "Pitch Deck")?.map((type, index) => {
                                                  return <MenuItem key={index} value={type?.value}>{type?.name}</MenuItem>
                                                })}
                                              </Select>
                                              {formik?.errors?.report_documents && formik.errors.report_documents[index] && formik.errors.report_documents[index].type_id && <CustomValidationText value={formik?.errors?.report_documents[index]?.type_id} />}
                                            </Grid>
                                            <Grid item xs={12} sm={3} pt={1}>
                                              <CustomLabel>UPLOAD FILE</CustomLabel>
                                              <CustomMenu>
                                                <Secondary
                                                  component="label"
                                                  role={undefined}
                                                  tabIndex={-1}
                                                  fullWidth
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    border: `1px solid ${theme.palette.customColors.g75}`,
                                                    borderRadius: "8px",
                                                    height: "52px",
                                                    padding: "10px, 14px, 10px, 14px",
                                                    color: '#7A7D83',
                                                    textTransform: 'none'
                                                  }}
                                                >
                                                  {item?.reports != null ? String(item?.reports?.name)?.length > 15 ? String(item?.reports?.name)?.substring(0, 15) + "..." : item?.reports?.name : "Upload"}
                                                  <UploadDocumentsIcon
                                                    style={{
                                                      width: 15,
                                                      height: 15,
                                                      stroke: "#344054",
                                                      padding: "8px",
                                                      borderRadius: "8px",
                                                      border: `1px solid ${theme.palette.customColors.gray300}`,
                                                    }}
                                                  />
                                                  <VisuallyHiddenInput
                                                    accept=".pdf,.png,.jpeg,.jpg,.mp4,.mov,.xlsx,.csv,.xls,.doc,.docx"
                                                    type="file"
                                                    name={`report_documents.${index}.reports`}
                                                    //  value={item?.reports}
                                                    id={`report_documents.${index}.reports`}
                                                    onChange={(e) => {
                                                      const file = e.target.files[0];
                                                      formik.setFieldValue(`report_documents.${index}.reports`, file);
                                                    }
                                                    }
                                                  />
                                                </Secondary>
                                              </CustomMenu>
                                              {formik?.errors?.report_documents && formik.errors.report_documents[index] && formik?.errors.report_documents[index]?.reports && <CustomValidationText value={formik?.errors.report_documents[index]?.reports} />}
                                            </Grid>

                                            <Grid item xs={12} sm={3} pt={1}>
                                              <CustomLabel sx={{ opacity: 0, display: { xs: 'none', sm: "block" } }}> Delete</CustomLabel>

                                              <Grid item xs={12}>
                                                <Secondary

                                                  onClick={() => {
                                                    arrayHelpers.remove(index);

                                                  }}
                                                  fullWidth
                                                  sx={{
                                                    color: theme.palette.customColors.r200,
                                                    padding: "12px, 24px, 12px, 24px",
                                                    border: `1px solid ${theme.palette.customColors.r100}`,
                                                    height: "52px",
                                                  }}
                                                >
                                                  Delete
                                                </Secondary>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </React.Fragment>
                                      ))}
                                    {/* {formik?.values?.report_documents?.length === 0 && */}
                                    <Grid container item columnSpacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                      {/* <Grid item xs={12} sm={3} pt={2} container alignItems={"center"} gap={1}>
                                  <Checkbox style={{ height: 20, width: 20, color: "#7c4dff" }} sx={{
                                    '& .MuiSvgIcon-root': {
                                      borderRadius: '8px',  // Change the border-radius value here
                                    }
                                  }} />
                                  <Typography variant='subtitle1' >
                                    Send report to investors
                                  </Typography>

                                </Grid> */}
                                      <Grid item xs={12} sm={3} pt={2} ml="auto">
                                        <Secondary
                                          ref={buttonRef}
                                          onClick={() => {
                                            arrayHelpers.insert(formik.values?.report_documents?.length, {
                                              document_name: '',
                                              type_id: "0",
                                              reports: null
                                            });
                                            scrollToBottom()
                                          }}
                                          fullWidth
                                          sx={{
                                            // padding: "12px, 24px, 12px, 24px",
                                            border: `1px solid ${theme.palette.customColors.b75}`,
                                            height: "52px",
                                          }}
                                        >
                                          Add Document
                                        </Secondary>

                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                )}
                              />
                            </Grid>}

                            {(hasPermission("startups_new", "view", userPermissions) || hasPermission("startups_new", "edit", userPermissions)) && isEditMode && reportDetailData?.documents && reportDetailData?.documents?.length > 0 && <Grid item container xs={12} paddingTop={2} id="report-documents-table">
                              <AsyncTableListing columns={columns} data={reportDetailData?.documents} actions={() => { }} RowActions={hasPermission("startups_new", "edit", userPermissions) ? RowActions : () => { return <></> }} backgroundColor="#fff" />
                            </Grid>}
                            {hasPermission("startups_new", "view", userPermissions) && <Grid item xs={12} sm={12} pt={2} sx={{ paddingTop: "0.5rem" }} container alignItems={"center"} gap={1}>
                              {/* <Checkbox style={{ height: 20, width: 20, color: "#7c4dff" }} sx={{
                                '& .MuiSvgIcon-root': {
                                  borderRadius: '8px',  // Change the border-radius value here
                                }
                              }}
                                // value={Boolean(formik.values?.share_investor)}
                                checked={formik.values?.share_investor}
                                onChange={(e) => {
                                  formik.setFieldValue("share_investor", e.target.checked);
                                }} /> */}
                              {/* <Typography variant='subtitle1' >
                              Send report to investors
                            </Typography> */}
                              {/* <Typography variant='subtitle1' sx={{ cursor: 'pointer' }} onClick={() => {
                                formik.setFieldValue("share_investor", !formik.values?.share_investor);
                                // console.log(formik.values?.share_investor)
                              }
                              }>
                                Show to investors
                              </Typography> */}
                              {/* / Need to be Updated // */}
                              {/* <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={formik.values?.share_investor}
                                    onChange={(e) => {
                                      formik.setFieldValue("share_investor", e.target.checked);
                                    }}
                                    // sx={{
                                    //   color: theme.palette.customColors.b300,
                                    //   "&.Mui-checked": {
                                    //     color: theme.palette.customColors.b300,
                                    //   },
                                    // }}
                                    style={{ height: 20, width: 20, color: "#7c4dff" }} sx={{
                                      '& .MuiSvgIcon-root': {
                                        borderRadius: '8px',  // Change the border-radius value here
                                      }
                                    }}
                                  />
                                }
                                sx={{marginLeft: 0.5, gap: 1 }}
                                label={"Show to investors"}
                              /> */}
                              {/* <Secondary
                                    ref={buttonRef}
                                    onClick={() => {
                                      arrayHelpers.insert(formik.values?.report_documents?.length, {
                                        document_name: '',
                                        type_id: "0",
                                        reports: null
                                      });
                                      scrollToBottom()
                                    }}
                                    fullWidth
                                    sx={{
                                      // padding: "12px, 24px, 12px, 24px",
                                      border: `1px solid ${theme.palette.customColors.b75}`,
                                      height: "52px",
                                    }}
                                  >
                                    Add Document
                                  </Secondary> */}

                            </Grid>}

                          </Grid>
                        </PerfectScrollbar>
                      </Card>
                    </Form>
                  </FormikProvider>
                  {/* </TabPanel> */}
                  <Grid
                    item
                    container
                    display={"flex"}
                    xs={12}
                    sm={12}
                    height={"min-content"}
                    gap={"1.5rem"}
                    justifyContent={"center"}
                    position={"absolute"}
                    bottom={0}
                    left={0}
                    bgcolor={theme.palette.customColors.yellow_bg}
                    padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 0rem 0rem" }}
                  >
                    {/* {currentIndex !== 1 &&  */}
                    {/* {currentIndex !== 0 && <Grid xs={5} sm={5} md={5.5} lg={5.7} item>
                    <Secondary
                      sx={{
                        textTransform: "none",
                        padding: 2,
                        borderWidth: 1,
                        borderRadius: "8px",
                      }}
                      type="no usetr"
                      onClick={() => {
                        if (currentIndex === 0) {
                          // navigate(-1);
                        } else {
                          setCurrentIndex(currentIndex - 1);
                        }
                        window.document
                          .getElementById("scrollable-form-round")
                          .scrollTo(0, 0);
                        // window.scrollTo(0, 0);
                      }}
                      fullWidth
                    >
                      Back
                    </Secondary>
                  </Grid>} */}
                    {/* } */}
                    <Grid xs={5} sm={5} md={4} lg={4} item>
                      <Secondary
                        sx={{
                          textTransform: "none",
                          padding: 2,
                          borderWidth: 1,
                          borderRadius: "8px",
                        }}
                        disabled={isAddingReport}
                        // sx={{ padding: 2, borderRadius: "8px", ":disabled": { color: '#d9d9d9' } }}
                        onClick={(e) => {
                          const hasChanges = hasFormChanges(formik?.values, isEditMode ? reportDetailData?.report : initialValues)
                          if (hasChanges) {
                            setHasUnsavedChanges(true);
                          } else {
                            navigate(-1);
                          }

                          // navigate(-1)
                          // formik.resetForm();
                          // handleFormSubmit(e, formik);
                          // formik.setValues({ ...initialValues, month: savedMetricDataByID?.month });
                        }}
                        fullWidth
                      >
                        Close
                      </Secondary>
                    </Grid>
                    {(hasPermission("startups_new", "edit", userPermissions) || hasPermission("startups_new", "add", userPermissions)) && <Grid xs={5} sm={5} md={4} lg={4} item>
                      <CustomButton
                        sx={{ padding: 2, borderRadius: "8px", ":disabled": { color: '#d9d9d9' } }}
                        onClick={(e) => {
                          // formik.handleSubmit();
                          // handleSubmit(e)
                          handleFormSubmit(e, formik)
                        }}
                        disabled={(!hasPermission("startups_new", "edit", userPermissions) || !hasPermission("startups_new", "add", userPermissions)) || isAddingReport}
                        // onClick={() => { setCurrentIndex(currentIndex + 1) }}
                        fullWidth
                      >
                        {(isAddingReport) ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.5rem'} /> : currentIndex == reportTabs?.length - 1 ? "Submit" : "Next"}
                      </CustomButton>
                    </Grid>}
                  </Grid>
                </Grid>
              </TabContext>
            </Grid>
          </Grid>
        </>}
    </ThemeBGWrapper>
  )
}

export default CreateReport